import React from 'react'
import actions from '../../actions/CarrierBrands'
import Component from './Component'
import ConnectedRemoteOptionsSelectField,
{ connectRemoteOptionsSelectField, defaultPropTypes }
  from './ConnectedRemoteOptionsSelectField'

export class CarrierBrandRemoteOptionsSelectField extends Component {
  static propTypes = defaultPropTypes

  static defaultProps = {
    label: 'Carrier Brand',
    multi: true,
    title: 'carrier_brand_ids'
  }

  render() {
    return (
      <ConnectedRemoteOptionsSelectField {...this.props} />
    )
  }
}

export default connectRemoteOptionsSelectField(CarrierBrandRemoteOptionsSelectField, 'carrier_brands', actions)
